import Chicago from "../components/Chicago";
function About() {
return (
    <Chicago />
)
}

export default About;